import { AxiosResponse } from "axios";
import { AxiosInstance } from "./axiosInstance";
import qs from "qs";
import {
  ChartLayoutResponse,
  DashboarAlertActiveResponse,
  DashboarAlertLatestResponse,
  DashboarDeviceResponse,
  DashboarFilterAccountAndUserResponse,
  DashboarUserLoginResponse,
  DashboardDeviceRequest,
  DashboardFilterAlertResponse,
  DashboardFilterRecorderResponse,
  DashboardFilterSearchRecordersRequest,
  KeywordSearchResposne,
} from "./interfaces/dashboardInterface.interface";
import { Layout } from "react-grid-layout";
import {
  BasePagination,
  CustomError,
} from "./interfaces/commonInterface.interface";
import { WidgetStatsPayload } from "./interfaces/widgetInterface.interface";

const API_PATH = "/dashboard";

// dashboard chart page gird layout 조회
export const getChartLayout = async (
  accountId: string
): Promise<ChartLayoutResponse> => {
  try {
    const { data }: AxiosResponse<ChartLayoutResponse> =
      await AxiosInstance.get(`${API_PATH}/chart/layout/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getKeywordList = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: BasePagination;
}): Promise<KeywordSearchResposne> => {
  try {
    const res: AxiosResponse<KeywordSearchResposne> = await AxiosInstance.get(
      `${API_PATH}/search/list/${accountId}?${qs.stringify(payload)}`
    );

    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getDashboardOverviewStatistic = async ({
  accountId,
}: {
  accountId: string;
}): Promise<DashboarAlertActiveResponse> => {
  try {
    const res: AxiosResponse<DashboarAlertActiveResponse> =
      await AxiosInstance.get(`${API_PATH}/stats/overview/${accountId}`);
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardUserLogin = async ({
  accountId,
  interval,
}: {
  accountId: string;
  interval: string;
}): Promise<DashboarUserLoginResponse> => {
  try {
    const res: AxiosResponse<DashboarUserLoginResponse> =
      await AxiosInstance.get(
        `${API_PATH}/stats/login/${accountId}/${interval}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getDashboardDevice = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: DashboardDeviceRequest;
}): Promise<DashboarDeviceResponse> => {
  try {
    const res: AxiosResponse<DashboarDeviceResponse> =
      payload.deviceTypes === null
        ? await AxiosInstance.get(`${API_PATH}/stats/device/${accountId}`)
        : await AxiosInstance.get(`${API_PATH}/stats/device/${accountId}`, {
            params: payload,
            paramsSerializer: (params) => {
              return qs.stringify(params, { arrayFormat: "repeat" });
            },
          });
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getFilterAccountUsers = async ({
  accountId,
}: {
  accountId: string;
}): Promise<DashboarFilterAccountAndUserResponse> => {
  try {
    const res: AxiosResponse<DashboarFilterAccountAndUserResponse> =
      await AxiosInstance.get(
        `${API_PATH}/filter/tree/accountsAndUsers/${accountId}`
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getFilterRecorders = async ({
  accountId,
}: {
  accountId: string;
}): Promise<DashboardFilterRecorderResponse> => {
  try {
    const res: AxiosResponse<DashboardFilterRecorderResponse> =
      await AxiosInstance.get(`${API_PATH}/filter/recorders/${accountId}`);
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postFilterSearchRecorders = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: DashboardFilterSearchRecordersRequest;
}): Promise<DashboardFilterAlertResponse> => {
  try {
    const res: AxiosResponse<DashboardFilterAlertResponse> =
      await AxiosInstance.post(
        `${API_PATH}/filter/recorders/${accountId}`,
        payload
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};
// dashboard chart page grid layout 저장
export const postChartLayout = async ({
  accountId,
  payload,
}: {
  accountId: string;
  payload: Layout[];
}): Promise<Layout[]> => {
  try {
    const { data }: AxiosResponse<Layout[]> = await AxiosInstance.post(
      `${API_PATH}/chart/layout/${accountId}`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};
export const postDashboardAlertLatest = async ({
  accountId,
  maxCount,
  payload,
}: {
  accountId: string;
  maxCount: number;
  payload: WidgetStatsPayload;
}): Promise<DashboarAlertLatestResponse> => {
  try {
    const res: AxiosResponse<DashboarAlertLatestResponse> =
      await AxiosInstance.post(
        `${API_PATH}/alert/latest/${accountId}/${maxCount}`,
        payload
      );
    return res.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};
